import React from "react";
import Icon from "@ant-design/icons";
import locationIcon from "../../../assets/Svg/location.png";

const LocationSvg = () => <img src={locationIcon} alt="" />;

const LocationIcon = (props) => <Icon component={LocationSvg} {...props} />;

export default LocationIcon;
